import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { isLoadingSelector } from 'src/store/selectors/statusSelector';
import { useSelector } from 'react-redux';
import { CANCEL_CFDI } from 'src/store/constants/CFDI';
import { InvoiceTypes } from 'src/utils/constants/cfdi';
import { isOlderThan72BusinessHours } from 'src/utils/businessDays';
import StepTwoReceipts from './StepTwoReceipts';
import StepTwo from './StepTwo';
import StepOne from './StepOne';

const CurrentStep = ({
  activeStep,
  data,
  onNext,
  onBack,
  onSubmit,
  open,
  resetRef,
  createdAt,
  amount,
  onClose
}) => {
  const isLoadingInvoiceCancellation = useSelector(
    isLoadingSelector([CANCEL_CFDI.action])
  );
  const [isOlderThan72Hours, setIsOlderThan72Hours] = useState(false);
  const isAmountMoreThan5000 = amount > 5000;

  useEffect(() => {
    let active = true;
    isOlderThan72BusinessHours(createdAt).then(result => {
      if (active) setIsOlderThan72Hours(result);
    });
    return () => {
      active = false;
    };
  }, [createdAt]);

  if (activeStep === 0) {
    return (
      <StepOne
        data={data}
        handleNext={onNext}
        handleBack={onBack}
        onClose={onClose}
        isLoadingInvoiceCancellation={isLoadingInvoiceCancellation}
        resetRef={resetRef}
        open={open}
      />
    );
  }

  if (data.invoiceType === InvoiceTypes.PAYMENT) {
    return (
      <StepTwoReceipts
        data={data}
        loading={isLoadingInvoiceCancellation}
        handleBack={onBack}
        handleSubmit={onSubmit}
        resetRef={resetRef}
        isOlderThan72Hours={isOlderThan72Hours}
        isAmountMoreThan5000={isAmountMoreThan5000}
      />
    );
  }

  return (
    <StepTwo
      data={data}
      loading={isLoadingInvoiceCancellation}
      handleBack={onBack}
      handleSubmit={onSubmit}
      resetRef={resetRef}
      onClose={onClose}
      isOlderThan72Hours={isOlderThan72Hours}
      isAmountMoreThan5000={isAmountMoreThan5000}
    />
  );
};

CurrentStep.propTypes = {
  activeStep: PropTypes.number.isRequired,
  open: PropTypes.bool.isRequired,
  data: PropTypes.any.isRequired,
  onNext: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  resetRef: PropTypes.object.isRequired,
  createdAt: PropTypes.any,
  amount: PropTypes.any,
  onClose: PropTypes.func.isRequired
};

export default CurrentStep;
